import React, { lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { trackAddToCart } from '../../utils/metaPixel';
import { HeadphonesIcon } from 'lucide-react';
interface UpsellModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function UpsellModal({
  isOpen,
  onClose
}: UpsellModalProps) {
  return <AnimatePresence data-id="element-105">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-id="element-106">
          <motion.div initial={{
        opacity: 0,
        scale: 0.85,
        y: 30
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.85,
        y: 30
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} onClick={e => e.stopPropagation()} className="relative bg-gradient-to-b from-[#111111] to-[#0A0A0A] border-2 border-[#D4AF37]/40 rounded-2xl max-w-md w-full p-6 max-sm:p-5 shadow-[0_0_60px_rgba(212,175,55,0.15)] overflow-hidden" data-id="element-107">
            {/* Glow effect */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[300px] h-[300px] bg-[#D4AF37]/10 rounded-full blur-[100px] pointer-events-none" data-id="element-108" />

            <div className="relative z-10 text-center" data-id="element-109">
              <span className="inline-block bg-[#FF3B3B]/15 text-[#FF3B3B] text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-4 animate-pulse" data-id="element-110">
                🔥 ¡ESPERA! OFERTA EXCLUSIVA
              </span>

              <h3 className="text-2xl max-sm:text-xl font-serif font-black text-[#E8E0D0] mb-2" data-id="element-111">
                ¡Puedes llevarte el Bono 5!
              </h3>
              <p className="text-[#A09880] text-sm mb-5" data-id="element-112">
                Optimiza aún más tus tareas con 100 Prompts Premium exclusivos
              </p>

              <div className="w-44 max-sm:w-36 mx-auto mb-5" data-id="element-113">
                <img src="https://cdn.magicpatterns.com/uploads/c3y47ihGiKAndN4p2kw3ZS/BONO_5.png" alt="Bono 5: El Vault Secreto - 100 Prompts Premium" loading="lazy" className="w-full h-auto rounded-lg shadow-[0_0_25px_rgba(212,175,55,0.2)]" data-id="element-114" />
              </div>

              <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-xl p-4 mb-5" data-id="element-115">
                <p className="text-[#D4AF37] font-bold text-lg mb-1" data-id="element-116">
                  🎁 El Vault Secreto
                </p>
                <p className="text-[#A09880] text-sm mb-2" data-id="element-117">
                  100 Prompts Premium para dominar la IA
                </p>
                <div className="flex items-center justify-center gap-3" data-id="element-118">
                  <span className="text-[#A09880]/70 line-through text-sm" data-id="element-119">
                    $27
                  </span>
                  <span className="text-3xl max-sm:text-2xl font-black text-[#D4AF37]" data-id="element-120">
                    Solo $4.99
                  </span>
                </div>
              </div>

              <button onClick={() => {
            trackAddToCart();
            window.open('https://www.betterdailyguides.com/cart/51865067389230:1', '_blank');
            onClose();
          }} className="w-full bg-gradient-to-r from-[#D4AF37] to-[#B8962E] text-[#0A0A0A] font-black text-lg max-sm:text-base py-4 px-6 rounded-xl shadow-[0_0_30px_rgba(212,175,55,0.3)] hover:shadow-[0_0_50px_rgba(212,175,55,0.5)] transition-all transform hover:scale-[1.02] active:scale-95 mb-4 uppercase tracking-wide" data-id="element-121">
                ¡SÍ! QUIERO EL BONO 5 POR $4.99
              </button>

              <button onClick={() => {
            trackAddToCart();
            window.open('https://www.betterdailyguides.com/cart/51863601938734:1', '_blank');
            onClose();
          }} className="text-[#A09880] hover:text-[#E8E0D0] text-xs underline underline-offset-4 transition-colors" data-id="element-122">
                No gracias, continuar sin el bono FINAL →
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}